import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLProgressElement extends HTMLElement { constructor(tagName: string = 'PROGRESS', ownerDocument?: any) { super(tagName, ownerDocument); } }
